import select from 'dom-select'

const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing')

    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
  }
}

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing')

  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)

// Remove tabindex="1" attributes from footer newsletter which is generated from LightBox service
const removePositiveTabindexFromLightBox = () => {
  const newsletterEl = select('.js-footer-newsletter')
  if (!newsletterEl) {
    return
  }
  const observer = new window.MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.type === 'childList') {
        const iframeEl = select('iframe', newsletterEl)
        if (!iframeEl) {
          return
        }
        iframeEl.removeAttribute('tabindex')
      }
    }
  })
  observer.observe(newsletterEl, {
    childList: true
  })
}

const moveCookieBarBeforePageContent = () => {
  const COOKIE_BAR_ID = 'hulk_cookie_bar'
  const SKIP_LINK_SELECTOR = '#skip-to-main-content'

  const skipLink = select(SKIP_LINK_SELECTOR)

  const cookieBarObserver = new window.MutationObserver(mutations => {
    mutations.map(mutation => {
      [...mutation.addedNodes].map(addedNode => {
        const { firstChild } = addedNode
        if (skipLink && firstChild && firstChild.id === COOKIE_BAR_ID) {
          insertAfter(addedNode, skipLink)
          setAriaAttrCookie(addedNode)
          stopObserver()
        }
      })
    })
  })

  const setAriaAttrCookie = (el) => {
    el.setAttribute('role', 'region')
    el.setAttribute('aria-label', 'cookie consent banner')
  }

  const insertAfter = (newNode, existingNode) => {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling)
  }

  const stopObserver = () => {
    cookieBarObserver.disconnect()
  }

  if (document.body) {
    cookieBarObserver.observe(document.body, {
      childList: true
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  removePositiveTabindexFromLightBox()
  moveCookieBarBeforePageContent()
})
